import { createAction } from '@reduxjs/toolkit';

const namespace = 'system';
export const systemRehydrate = createAction(`${namespace}/rehydrate`);
